import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "services-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "professional-development-blurb",
  class: "text-blue"
}, " CARE Behavioral Health works directly with the school district to tailor the support they need to make their students and staff members successful. CARE BH provides training on evidenced-based approaches and practices for students with ASD and related disorders as well as provides training on how to work effectively with students with and without disabilities who are engaging in challenging behavior. CARE BH has also developed a more intensive technical assistance model called the Collaborative Technical Assistance and Support (CTAS) that provides ongoing coaching and support to a school district striving to make sustainable system changes while building capacity. ", -1)
const _hoisted_3 = { class: "text-blue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StandardPageHeader = _resolveComponent("StandardPageHeader")!
  const _component_LinkList = _resolveComponent("LinkList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StandardPageHeader, {
      icon: '/icons/work-experience-icon.svg',
      title: 'Consultative Services'
    }),
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Consultations, (section, sectionKey) => {
      return (_openBlock(), _createElementBlock("div", {
        key: sectionKey,
        class: "list-section mlr-auto"
      }, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.makeTitle(sectionKey)), 1),
        _createVNode(_component_LinkList, {
          class: "flex column",
          "link-section": section,
          "text-color-class": 'text-link-blue',
          internal: true
        }, null, 8, ["link-section"])
      ]))
    }), 128))
  ]))
}